import { render, staticRenderFns } from "./WebcamForm.vue?vue&type=template&id=48295b26&"
import script from "./WebcamForm.vue?vue&type=script&lang=js&"
export * from "./WebcamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports